import baseApi from "./base-api";

/**
 * @typedef GetStatsBaseParams
 * @property {string} params.year
 * @property {string[]} params.organizationId
 * @property {string[]} params.teamIds
 * @property {import('../typedefs').PlatformFlow} params.platformFlow
 * @property {string} params.dateRangeStart
 * @property {string} params.dateRangeEnd
 * @property {boolean} params.useCache
 */

function getGlobalStats() {
    const params = {};

    if (localStorage.getItem('disable-cache') === 'true') {
        params.useCache = "false";
    }

    return baseApi.getWithParams("v2/webadmin/stats/global-stats", params);
}

/**
 * @param {GetStatsBaseParams} params
 */
function getAppreciationStats(params = {}) {
    if (localStorage.getItem('disable-cache') === 'true') {
        params.useCache = "false";
    }

    return baseApi.getWithParams("v2/webadmin/stats", params);
}

/**
 * @param {GetStatsBaseParams} params
 */
function getEngagementStats(params = {}) {
    if (localStorage.getItem('disable-cache') === 'true') {
        params.useCache = 'false';
    }

    return baseApi.getWithParams("v2/webadmin/stats/engagement-stats", params);
}

/**
 * @param {string[]} organizationId
 */
function refreshStatsCache(organizationId) {
    return baseApi.getWithParams("v2/webadmin/stats/refresh-cache", {
        organizationId: organizationId,
    });
}

const statsService = {
    getGlobalStats: getGlobalStats,
    getAppreciationStats: getAppreciationStats,
    getEngagementStats: getEngagementStats,
    refreshStatsCache: refreshStatsCache,
};

export default statsService;
